import {createSinglePathSVG} from './TEMPLATE'

export const Paragraph_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 16 16',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  path: 'M11.6667 2.66667V13.3333M13 2.66667H6C4.52724 2.66667 3.33333 3.86057 3.33333 5.33333C3.33333 6.80609 4.52724 8 6 8H9.33333M9.33333 2.66667V13.3333M8 13.3333H13',
})
